export default "__VITE_ASSET__C1d6n6k5__"